module.exports = __webpack_public_path__ + "img/Leaderboard.4567ed61.png";